<div class="card">
  <div class="card-header">
    <span class="card-title">{{ title }}</span>
    <mat-progress-bar
      class="progress-bar"
      mode="indeterminate"
      *ngIf="loading"
    ></mat-progress-bar>
  </div>
  <div class="card-body max-60vh">
    <div class="row">
      <div class="col">
        <mat-form-field
          appearance="outline"
          [ngClass]="{
            hilite:
              readOnly && data.aplGroup.name != data.aplGroup.newVersion?.name
          }"
        >
          <mat-label>
            <span [innerHTML]="labelName"></span>
          </mat-label>
          <input
            matInput
            name="name"
            [disabled]="loading"
            [(ngModel)]="aplGroup.name"
            [disabled]="readOnly"
          />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <comments-box
          [hilite]="
            readOnly &&
            data.aplGroup.description != data.aplGroup.newVersion?.description
          "
          [textValue]="aplGroup.description"
          [disabled]="loading || readOnly"
          [formType]="'APL'"
          [serialNo]="'Files'"
          title="Description"
          (textChanged)="aplGroup.description = $event"
        ></comments-box>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <user-chip
          [placeholder]="labelManagers"
          [disabled]="loading || readOnly"
          [relatedId]="aplGroup.id"
          [selectedUsers]="aplGroup.aplGroupManagers ?? []"
          (error)="alert.error($event)"
          [hilite]="readOnly && diffManagers()"
        ></user-chip>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <role-chip
          [placeholder]="labelRoles"
          [disabled]="loading || readOnly"
          [relatedId]="aplGroup.id"
          [roles]="aplGroup.aplGroupRoles ?? []"
          [selectedRoles]="rolesSelected"
          (error)="alert.error($event)"
          [hilite]="readOnly && diffRoles()"
        ></role-chip>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <user-chip
          [placeholder]="labelProcedureTrainingCoordinators"
          [disabled]="loading || readOnly"
          [relatedId]="aplGroup.id"
          [selectedUsers]="aplGroup.aplProcedureTrainingCoordinators ?? []"
          [aplGroup]="aplGroup"
          (error)="alert.error($event)"
          [hilite]="readOnly && diffTraining()"
        ></user-chip>
      </div>
    </div>
  </div>

  <div class="card-footer">
    <div mat-dialog-actions align="center">
      <button
        mat-flat-button
        color="warn"
        type="button"
        [disabled]="loading"
        (click)="cancel()"
      >
        <span [innerHTML]="labelCancel"></span>
      </button>
      <button
        *ngIf="!readOnly"
        mat-flat-button
        color="primary"
        type="button"
        [disabled]="loading"
        (click)="submit()"
      >
        <span [innerHTML]="labelAccept"></span>
      </button>
    </div>
  </div>
</div>
